import React, { useState, createContext } from 'react'

let user = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : { isAdmin: false }
export const AuthContext = createContext()

const AuthContextProvider = (props) => {
    const [User, setUser] = useState(user)

    return (
        <AuthContext.Provider value={{ User, setUser }}>
            {props.children}
        </AuthContext.Provider>
    )
}

export default AuthContextProvider
